import { formatMessageTime } from '~/portal/i18n/dates'

export const formatCurrency = (fee, currency = 'USD', placeholder = '') => {
  return fee ? new Intl.NumberFormat("en-US", { style: "currency", currency }).format(fee) : placeholder
}

// A message time in the page's language: the clock time today, otherwise the time and a short date.
export const formatDate = (inputDate) => {
  // Safari can't parse Rails' "2026-11-04 15:05:00 UTC" with dashes.
  const date = typeof inputDate == 'string'
    ? new Date(inputDate.replace(/(\d{4})-(\d{2})-(\d{2})/, '$1/$2/$3'))
    : new Date(inputDate)
  return formatMessageTime(date)
}

export const startCase = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getFileSuffix = (filename = '') => {
  return filename.split('.').pop()
}